import commentService from '../services/commentService';
import courseCommentService from '../../course/services/commentService'

import { CommentAction } from '../types/CommentAction';
import CommentBody from '../types/CommentBody';

const getCommentList = (contentId: string, status: string, limit: number, skip: number) => (dispatch: any) => {
  const success = (data: CommentBody[]): CommentAction =>
    ({ type: 'GET_COMMENT_LIST', data });

  commentService.getComments(contentId, status, limit, skip)
    .then(
      (res: any) => { dispatch(success(res)) },
    );
}

const getCommentListCourse = (courseID: string, status: string, limit: number, skip: number) => (dispatch: any) => {
  const success = (data: CommentBody[]): CommentAction =>
    ({ type: 'GET_COMMENT_LIST', data });
    courseCommentService.getComments(status,courseID)
    .then(
      (res: any) => { dispatch(success(res)) },
    );
}

// const deleteComment = (commentId: string) => (dispatch: any) => {
//   const success = (data: any): CommentAction =>
//     ({ type: 'DELETE_COMMENT', data });

//   commentService.deleteComment(commentId)
//     .then(
//       (res: any) => { res && dispatch(success({ _id: commentId }))},
//     );
// }

const getCommentCount = (contentId: string, status: string) => (dispatch: any) => {
  const success = (data: number): CommentAction =>
    ({ type: 'GET_COUNT', data });
  commentService.getCommentCount(contentId)
    .then(
      (res: any) => {  
        // if(res > 0){
          dispatch(success(res >0 ?res : 0))
        // }  
      },
    ).catch(() => {});
}

const clearComment = () => (dispatch: any) => {
  const success = (): CommentAction =>
    ({ type: 'CLEAR_COMMENT' });
  dispatch(success())
}

export {
  getCommentList,
  getCommentCount,
  getCommentListCourse,
  // deleteComment,
  clearComment
};